<template>
  <!-- 공지사항 다이올로그 -->
  <v-dialog v-model="bDialog" :max-width="DialogMaxWidth">
    <v-card>
      <div class="font-weight-bold d-flex pa-4 pb-2">
        <v-icon color="black" class="mr-2 pt-1 align-self-start">mdi-account-voice</v-icon>
        <div class="text-h6 font-weight-bold">
          {{DataItem.cNotiBoardNm}}<br>
          <div class="text-subtitle-1 font-weight" style="line-height:140%">
            {{DataItem.cCreateDateTime.substring(0,19)}}<br>
            조회수 : {{DataItem.iShowCount}}
          </div>
        </div>
        <v-spacer></v-spacer>
        <div v-for="(item,index) in zPopUpDataItem" :key="item.cNotiBoardId">
          <v-checkbox v-if="iPopUpIndex > -1 && iPopUpIndex == index" v-model="item.bNoShow" class="mt-0 mr-2" color="black" hide-details style="padding-top:2px;">
            <template v-slot:label>
              <div class="black--text">
                다시 보지 않기
              </div>
            </template>
          </v-checkbox>
        </div>
        <v-btn color="black darken-2" text @click="Close()" class="font-weight-bold text-subtitle-1 mt-n1 align-self-start">
          <v-icon class="mr-2">mdi-close</v-icon>닫기
        </v-btn>
      </div>
      <div style="height:calc(100vh - 500px);min-height:200px;" class="pa-2 pr-4 pl-4 mb-2 d-flex justify-space-between align-center">
        <v-btn @click="PrePopUp()" v-if="bPopUp" icon large class="mr-2 ml-n2"><v-icon color="black" style="font-size:45px;">mdi-chevron-left</v-icon></v-btn>
        <editorRead
          style="padding:5px !important; width:100%; "
          ref="QuillEditorRead"
          class="ql-editor"
          v-model="DataItem.cData"
        ></editorRead>
        <v-btn @click="NextPopUp()" v-if="bPopUp" icon large class="ml-2 mr-n2"><v-icon color="black" style="font-size:45px;">mdi-chevron-right</v-icon></v-btn>
      </div>
      <div class="pa-2 pt-0">
        <v-row class="ma-0">
          <v-col cols="12">
            <v-text-field v-model="DataItem.cFileNm" label="첨부파일" placeholder="등록된 첨부파일이 없습니다." persistent-placeholder dense hide-details readonly>
              <template v-slot:append-outer>
                <v-btn v-show="DataItem.cPath != ''" @click="DownloadFile()" dark small><v-icon small class="mr-1">mdi-download</v-icon>다운로드</v-btn>
                <v-btn v-show="DataItem.cPath == ''" @click="DownloadFile()" disabled small><v-icon small class="mr-1">mdi-download</v-icon>다운로드</v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import EditorRead from "../views/EditorRead.vue";
import EventBus from '@/eventBus.js';
import axios from "axios"
// import BasicInfo from "@/BasicInfo.js";

export default {
  components: {   
    EditorRead,          
  },

  data: () => ({ 
    bDialog: false,
    bPopUp: false,
    iPopUpIndex: -1,
    DialogMaxWidth: "",
    oPopupList: [],
    zPopUpDataItem: [],
    DataItem: {
      sType: "",
      cNotiBoardNm: "",
      cCreateDateTime: "",
      cColor: "",
      cIcon: "",
      cData : "",
      iShowCount : "",
      cFileId : "",
      cFileNm : "",
      cPath : "",
    },
    defaultDataItem: {
      sType: "",
      cNotiBoardNm: "",
      cCreateDateTime: "",
      cColor: "",
      cIcon: "",
      cData : "",
      iShowCount : "",
      cFileId : "",
      cFileNm : "",
      cPath : "",
    },
  }),

  computed: {
  },

  created() {    
  },

  methods: {
    Initialize(BannerList) {
      this.DataItem = BannerList;

      if (this.DataItem.cFileId == "NONE" || this.DataItem.cFileId == "") {
        this.DataItem.cFileNm = "등록된 첨부파일이 없습니다."
        this.DataItem.cPath = ""
      }
      
      setTimeout(() => {
        try {
          this.$refs.QuillEditorRead.refresh(this.DataItem.cData);  
        } catch (error) {
          EventBus.$emit("onShowMsg", true,""+error);
        }  
      }, 100);
    },

    DownloadFile() {
      if (this.DataItem.cPath == "") {
        return
      }

      axios({
        url: process.env.VUE_APP_FILE_API + this.DataItem.cPath,
        method: 'GET',
        responseType: 'blob', 
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.DataItem.cFileNm); 
          document.body.appendChild(link);
          link.click();
        });      
    },

    ShowDialog(bPopUp,BannerList,NoPopupList) {
      this.bDialog = true;
      this.bPopUp = bPopUp
      this.zPopUpDataItem = [];


      console.log(bPopUp,BannerList,NoPopupList);

      if (!bPopUp) {
        this.DialogMaxWidth = "700px"
        this.Initialize(BannerList[0]);
      } else {
        this.DialogMaxWidth = "900px"
        this.oPopupList = NoPopupList
        this.zPopUpDataItem = BannerList;
        this.iPopUpIndex = 0;
        this.DataItem = BannerList[this.iPopUpIndex]

        if (this.DataItem.cFileId == "NONE" || this.DataItem.cFileId == "") {
          this.DataItem.cFileNm = "등록된 첨부파일이 없습니다."
          this.DataItem.cPath = ""
        }
      }
    },

    Close() {
      for (let i = 0; i < this.zPopUpDataItem.length;i++) {
        if (this.zPopUpDataItem[i].bNoShow) {
          this.oPopupList.push(this.zPopUpDataItem[i].cNotiBoardId)
        }
      }

      const cPopUpData = JSON.stringify(this.oPopupList);
      localStorage.setItem("cPopUpInfo",cPopUpData)
      
      this.DataItem = Object.assign({}, this.defaultDataItem);
      this.bDialog = false;
    },

    PrePopUp() {
      if (this.iPopUpIndex == 0) {
        this.iPopUpIndex = this.zPopUpDataItem.length-1
      } else {
        this.iPopUpIndex = this.iPopUpIndex - 1
      }

      this.DataItem = this.zPopUpDataItem[this.iPopUpIndex]
      if (this.DataItem.cFileId == "NONE" || this.DataItem.cFileId == "") {
        this.DataItem.cFileNm = "등록된 첨부파일이 없습니다."
        this.DataItem.cPath = ""
      }
      setTimeout(() => {
        try {
          this.$refs.QuillEditorRead.refresh(this.DataItem.cData);  
        } catch (error) {
          EventBus.$emit("onShowMsg", true,""+error);
        }  
      }, 10);
    },

    NextPopUp() {
      if (this.iPopUpIndex == this.zPopUpDataItem.length-1) {
        this.iPopUpIndex = 0
      } else {
        this.iPopUpIndex = this.iPopUpIndex + 1
      }

      this.DataItem = this.zPopUpDataItem[this.iPopUpIndex]
      if (this.DataItem.cFileId == "NONE" || this.DataItem.cFileId == "") {
        this.DataItem.cFileNm = "등록된 첨부파일이 없습니다."
        this.DataItem.cPath = ""
      }

      setTimeout(() => {
        try {
          this.$refs.QuillEditorRead.refresh(this.DataItem.cData);  
        } catch (error) {
          EventBus.$emit("onShowMsg", true,""+error);
        }  
      }, 10);
    },
  }
};
</script>
